export default function parseHtmlToString(htmlString: string) {
  const charCodesRegex = /&#(\d+);/g;
  return htmlString.replace(charCodesRegex, (_, code) =>
    String.fromCharCode(code),
  );
}
